import { p } from "./_helpers";

const peche = {
 slug: "peche",
 path: "/secteurs/peche",
 hero: {
 image: "/photos/sector-peche-hero.jpg",
 alt: p("Pirogues traditionnelles en Guinée-Bissau", "Traditional pirogues in Guinea-Bissau", "Pirogas tradicionais na Guiné-Bissau"),
 breadcrumb: p("Pêche & économie bleue", "Fishing & blue economy", "Pescas e economia azul"),
 title: p("Investir dans l'économie bleue.", "Investing in the blue economy.", "Investir na economia azul."),
 subtitle: p(
 "350 km de côte atlantique, mangroves, pêche artisanale : une richesse maritime encore largement inexploitée.",
 "350 km of Atlantic coastline, mangroves, artisanal fishing: a maritime wealth still largely untapped.",
 "350 km de costa atlântica, mangais, pesca artesanal: uma riqueza marítima ainda largamente por explorar."
 ),
 },
 seo: {
 title: p(
 "Investir dans la pêche et l'économie bleue en Guinée-Bissau | NANDA SÁ",
 "Investing in fishing and the blue economy in Guinea-Bissau | NANDA SÁ",
 "Investir nas pescas e na economia azul na Guiné-Bissau | NANDA SÁ"
 ),
 description: p(
 "Panorama de la pêche et de l'économie bleue en Guinée-Bissau : ressources, transformation, chaîne du froid, export. Chiffres clés, opportunités et passerelles NANDA SÁ.",
 "Panorama of fishing and blue economy in Guinea-Bissau: resources, processing, cold chain, export. Key figures, opportunities and NANDA SÁ pathways.",
 "Panorama das pescas e da economia azul na Guiné-Bissau: recursos, transformação, cadeia de frio, exportação. Dados-chave, oportunidades e pontes NANDA SÁ."
 ),
 keywords: "pêche Guinée-Bissau, économie bleue Afrique de l'Ouest, aquaculture, chaîne du froid, transformation poisson",
 },
 presentation: {
 title: p("Une mer généreuse, encore peu structurée.", "A generous sea, still lightly structured.", "Um mar generoso, ainda pouco estruturado."),
 paragraphs: p(
 [
 "La zone économique exclusive de la Guinée-Bissau couvre plus de 100 000 km² et fait partie des plus poissonneuses d'Afrique de l'Ouest. Ses mangroves accueillent crevettes, huîtres, poissons et une biodiversité rare. Pourtant, la pêche industrielle nationale est faible, et la transformation locale (surgélation, salage, séchage, conserverie) reste embryonnaire.",
 "L'accord de partenariat de pêche avec l'Union européenne, l'intérêt croissant de la coopération japonaise et les besoins de la région ouest-africaine dessinent un marché prometteur pour les investisseurs capables d'apporter équipements, chaîne du froid et savoir-faire.",
 ],
 [
 "Guinea-Bissau's exclusive economic zone covers more than 100,000 km² and is among the richest fishing grounds in West Africa. Its mangroves host shrimp, oysters, fish and a rare biodiversity. Yet national industrial fishing is weak, and local processing (freezing, salting, drying, canning) remains embryonic.",
 "The fisheries partnership agreement with the European Union, growing Japanese cooperation interest and West African regional needs outline a promising market for investors capable of bringing equipment, cold chain and know-how.",
 ],
 [
 "A zona económica exclusiva da Guiné-Bissau cobre mais de 100 000 km² e é uma das mais ricas em peixe da África Ocidental. Os seus mangais albergam camarão, ostras, peixe e uma biodiversidade rara. Contudo, a pesca industrial nacional é fraca e a transformação local (congelação, salga, secagem, conservaria) permanece embrionária.",
 "O acordo de parceria de pescas com a União Europeia, o interesse crescente da cooperação japonesa e as necessidades da região oeste-africana desenham um mercado promissor para investidores capazes de trazer equipamentos, cadeia de frio e saber-fazer.",
 ]
 ),
 },
 kpis: {
 title: p("Chiffres clés de la pêche", "Fishing key figures", "Dados-chave das pescas"),
 items: [
 { n: "> 100k km²", l: p("Zone économique exclusive", "Exclusive economic zone", "Zona económica exclusiva"), d: p("Parmi les plus poissonneuses de la sous-région.", "Among the richest in the sub-region.", "Entre as mais ricas em peixe da sub-região.") },
 { n: "350 km", l: p("De côte atlantique", "Of Atlantic coastline", "De costa atlântica"), d: p("Plages, estuaires, mangroves.", "Beaches, estuaries, mangroves.", "Praias, estuários, mangais.") },
 { n: "88", l: p("Îles aux Bijagós", "Bijagós islands", "Ilhas dos Bijagós"), d: p("Sanctuaire de biodiversité marine.", "Marine biodiversity sanctuary.", "Santuário de biodiversidade marinha.") },
 { n: "80 %+", l: p("Pêche artisanale", "Artisanal fishing", "Pesca artesanal"), d: p("Emplois locaux dépendants, marge de professionnalisation.", "Local jobs dependent, room to professionalise.", "Empregos locais dependentes, margem para profissionalizar.") },
 { n: "Rare", l: p("Chaîne du froid", "Cold chain", "Cadeia de frio"), d: p("Investissement structurant à faire.", "Structural investment to make.", "Investimento estruturante a fazer.") },
 { n: "UE + JPN", l: p("Accords bilatéraux actifs", "Active bilateral agreements", "Acordos bilaterais activos"), d: p("Cadre international sécurisé pour l'export.", "Secure international framework for export.", "Enquadramento internacional seguro para a exportação.") },
 ],
 sources: p(
 "Sources : FAO, ministère des Pêches Guinée-Bissau, accord UE-GNB, coopération japonaise, données 2023-2025.",
 "Sources: FAO, Guinea-Bissau Ministry of Fisheries, EU-GNB agreement, Japanese cooperation, data 2023-2025.",
 "Fontes: FAO, Ministério das Pescas Guiné-Bissau, acordo UE-GNB, cooperação japonesa, dados 2023-2025."
 ),
 },
 opportunites: {
 title: p("Segments d'investissement prioritaires", "Priority investment segments", "Segmentos de investimento prioritários"),
 intro: p(
 "Quatre segments complémentaires, de la mer à l'assiette.",
 "Four complementary segments, from sea to plate.",
 "Quatro segmentos complementares, do mar ao prato."
 ),
 segments: [
 { h3: p("1. Transformation & conserverie de poisson", "1. Fish processing & canning", "1. Transformação e conservaria de peixe"),
 p: p("Filetage, surgélation, conserves, sécage traditionnel. Marchés local et régional (Cap-Vert). Ticket : 300 000 à 1,5 M€.", "Filleting, freezing, canning, traditional drying. Local and regional markets. Ticket: €300k to €1.5M.", "Filetagem, congelação, conservas, secagem tradicional. Mercados local e regional. Ticket: 300 000 a 1,5 M€.") },
 { h3: p("2. Chaîne du froid & logistique portuaire", "2. Cold chain & port logistics", "2. Cadeia de frio e logística portuária"),
 p: p("Chambres froides, transport réfrigéré, container reefer. B2B fiable. Ticket : 200 000 à 800 000 €.", "Cold rooms, refrigerated transport, reefer container. Reliable B2B. Ticket: €200k to €800k.", "Câmaras frigoríficas, transporte refrigerado, contentor reefer. B2B fiável. Ticket: 200 000 a 800 000 €.") },
 { h3: p("3. Aquaculture (crevettes, tilapia, huîtres)", "3. Aquaculture (shrimp, tilapia, oysters)", "3. Aquicultura (camarão, tilápia, ostras)"),
 p: p("Élevage en bassins et en mangrove, très demandé à l'export. Ticket : 150 000 à 700 000 €.", "Pond and mangrove farming, in high export demand. Ticket: €150k to €700k.", "Cultura em tanques e em mangal, muito procurada para exportação. Ticket: 150 000 a 700 000 €.") },
 { h3: p("4. Écotourisme marin & pêche sportive premium", "4. Marine ecotourism & premium sport fishing", "4. Ecoturismo marinho e pesca desportiva premium"),
 p: p("Marché de niche à forte valeur, complémentaire de l'hôtellerie des Bijagós. Ticket : 80 000 à 300 000 €.", "High-value niche, complementary to Bijagós hospitality. Ticket: €80k to €300k.", "Nicho de alto valor, complementar da hotelaria dos Bijagós. Ticket: 80 000 a 300 000 €.") },
 ],
 },
 defis: {
 title: p("Les défis à anticiper", "Challenges to anticipate", "Desafios a antecipar"),
 intro: p(
 "L'économie bleue exige rigueur environnementale et discipline logistique.",
 "The blue economy requires environmental rigour and logistical discipline.",
 "A economia azul exige rigor ambiental e disciplina logística."
 ),
 items: p(
 [
 "Un cadre de licences de pêche à respecter strictement (quotas, zones, saisons).",
 "Une pression écologique croissante, la surpêche est un vrai risque.",
 "Une infrastructure portuaire à moderniser à Bissau.",
 "Une chaîne du froid quasi absente, à intégrer dans tout projet sérieux.",
 "Une main-d'œuvre à former aux standards internationaux (HACCP, IFS, MSC).",
 ],
 [
 "A fisheries licensing framework to respect strictly (quotas, zones, seasons).",
 "Growing ecological pressure, overfishing is a real risk.",
 "Port infrastructure to modernise in Bissau.",
 "A near-absent cold chain, to be integrated into any serious project.",
 "Workforce to be trained to international standards (HACCP, IFS, MSC).",
 ],
 [
 "Um enquadramento de licenças de pesca a respeitar estritamente (quotas, zonas, épocas).",
 "Uma pressão ecológica crescente, a sobrepesca é um risco real.",
 "Uma infra-estrutura portuária a modernizar em Bissau.",
 "Uma cadeia de frio quase ausente, a integrar em qualquer projecto sério.",
 "Uma mão-de-obra a formar nos padrões internacionais (HACCP, IFS, MSC).",
 ]
 ),
 closing: p(
 "L'investissement responsable est aujourd'hui la seule voie d'entrée durable dans cette filière.",
 "Responsible investment is today the only sustainable entry into this sector.",
 "O investimento responsável é hoje a única via de entrada duradoura nesta fileira."
 ),
 },
 pourquoi: {
 title: p("Un partenaire pour l'économie bleue durable.", "A partner for a sustainable blue economy.", "Um parceiro para a economia azul sustentável."),
 paragraphs: p(
 [
 "NANDA SÁ orchestre les projets d'économie bleue avec un souci constant d'équilibre écologique et de rentabilité. Notre pôle Conseil en implantation vous guide dans les licences, les partenariats communautaires et la structuration commerciale.",
 "Nous nous appuyons sur les cadres internationaux existants (accord UE, coopération japonaise) et sur nos relations avec les autorités portuaires et les communautés côtières.",
 ],
 [
 "NANDA SÁ orchestrates blue economy projects with a constant concern for ecological balance and profitability. Our Establishment Advisory guides you through licences, community partnerships and commercial structuring.",
 "We rely on existing international frameworks (EU agreement, Japanese cooperation) and on our relationships with port authorities and coastal communities.",
 ],
 [
 "A NANDA SÁ orquestra os projectos de economia azul com uma preocupação constante de equilíbrio ecológico e rentabilidade. A nossa Consultoria de implantação guia-o nas licenças, parcerias comunitárias e estruturação comercial.",
 "Apoiamo-nos nos enquadramentos internacionais existentes (acordo UE, cooperação japonesa) e nas nossas relações com as autoridades portuárias e as comunidades costeiras.",
 ]
 ),
 bullets: p(
 [
 "Étude ressources & quotas",
 "Licences et démarches auprès du ministère des Pêches",
 "Partenariats avec communautés côtières",
 "Chaîne du froid et logistique portuaire",
 "Certifications MSC, HACCP, IFS",
 ],
 [
 "Resources & quota study",
 "Licences and Ministry of Fisheries procedures",
 "Partnerships with coastal communities",
 "Cold chain and port logistics",
 "MSC, HACCP, IFS certifications",
 ],
 [
 "Estudo de recursos e quotas",
 "Licenças e diligências junto do Ministério das Pescas",
 "Parcerias com comunidades costeiras",
 "Cadeia de frio e logística portuária",
 "Certificações MSC, HACCP, IFS",
 ]
 ),
 },
 download: {
 title: p("Télécharger la note « Économie bleue · Guinée-Bissau ».", "Download the brief « Blue economy · Guinea-Bissau ».", "Descarregar a nota « Economia azul · Guiné-Bissau »."),
 body: p(
 "Une note préparée par NANDA SÁ : chiffres clés, segments d'investissement, cadre réglementaire et contacts utiles.",
 "A brief prepared by NANDA SÁ: key figures, investment segments, regulatory framework and useful contacts.",
 "Uma nota preparada pela NANDA SÁ: dados-chave, segmentos de investimento, enquadramento regulatório e contactos úteis."
 ),
 pdfUrl: "/pdf/nanda-sa-note-peche.pdf",
 pdfFilename: "nanda-sa-note-peche.pdf",
 mailSubject: p("Téléchargement de la note « Économie bleue · Guinée-Bissau »", "Download of the brief « Blue economy · Guinea-Bissau »", "Descarga da nota « Economia azul · Guiné-Bissau »"),
 mailBody: p(
 "Bonjour, je souhaite recevoir la note « Économie bleue · Guinée-Bissau ». Merci de me tenir informé(e) des prochaines publications de NANDA SÁ.",
 "Hello, I would like to receive the brief « Blue economy · Guinea-Bissau ». Please keep me informed of NANDA SÁ's next publications.",
 "Olá, gostaria de receber a nota « Economia azul · Guiné-Bissau ». Por favor, mantenha-me informado(a) das próximas publicações da NANDA SÁ."
 ),
 },
 contact: {
 title: p("Parlons de votre projet maritime.", "Let's talk about your maritime project.", "Falemos do seu projecto marítimo."),
 body: p(
 "Armateur, transformateur, exportateur, ONG, coopérative de pêche, institution : décrivez votre intention, nous répondons personnellement.",
 "Ship-owner, processor, exporter, NGO, fishing cooperative, institution: describe your intention, we respond personally.",
 "Armador, transformador, exportador, ONG, cooperativa de pesca, instituição: descreva a sua intenção, respondemos pessoalmente."
 ),
 quote: p(
 "La mer ne donne pas deux fois. Elle demande d'être écoutée avant d'être exploitée.",
 "The sea does not give twice. It must be listened to before being exploited.",
 "O mar não dá duas vezes. Exige ser escutado antes de ser explorado."
 ),
 subject: p("Investir dans l'économie bleue en Guinée-Bissau", "Invest in the blue economy in Guinea-Bissau", "Investir na economia azul na Guiné-Bissau"),
 },
 ctas: ["Conseil"],
};

export default peche;
